const ListUsers = ()=>import("./UserList.vue");
const router = {
    path:"users",
    component:ListUsers
};
export default router;